<!-- Collapsible container -->
<div class="mb-6 bg-white rounded-2xl border border-gray-200/80 shadow-sm overflow-hidden">

  <!-- Header (always visible) -->
  <div class="flex items-center justify-between px-5 py-3.5 cursor-pointer select-none hover:bg-gray-50 transition-colors"
       (click)="toggleExpanded()">
    <div class="flex items-center gap-2.5">
      <div class="w-8 h-8 bg-gradient-to-br from-amber-100 to-orange-100 rounded-lg flex items-center justify-center">
        <i class="fa-solid fa-chart-line text-amber-600 text-sm"></i>
      </div>
      <span class="text-sm font-semibold text-gray-700">{{ 'CREDIT_USAGE' | translate }}</span>
    </div>
    <i class="fa-solid text-gray-400 text-xs transition-transform duration-200"
       [ngClass]="expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
  </div>

  <!-- Expandable body -->
  <div *ngIf="expanded" class="px-5 pb-5 border-t border-gray-100">

    <!-- Time range pills -->
    <div class="flex flex-wrap gap-1.5 mt-4 mb-3">
      <button *ngFor="let r of ranges"
              (click)="onRangeChange(r.key)"
              class="px-3 py-1 text-xs font-medium rounded-full transition-all"
              [ngClass]="activeRange === r.key
                ? 'bg-amber-500 text-white shadow-sm'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'">
        {{ r.label | translate }}
      </button>
    </div>

    <!-- Custom date range -->
    <div *ngIf="activeRange === 'custom'" class="flex flex-wrap items-center gap-2 mb-3">
      <input type="date"
             [(ngModel)]="customFrom"
             [min]="minDate"
             [max]="customTo || maxDate"
             (change)="onCustomRangeChange()"
             class="px-2.5 py-1 text-xs border border-gray-200 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-amber-300">
      <span class="text-xs text-gray-400">-</span>
      <input type="date"
             [(ngModel)]="customTo"
             [min]="customFrom || minDate"
             [max]="maxDate"
             (change)="onCustomRangeChange()"
             class="px-2.5 py-1 text-xs border border-gray-200 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-amber-300">
    </div>

    <!-- View tabs + Project filter -->
    <div class="flex flex-wrap items-center justify-between gap-2 mb-3">
      <div class="flex flex-wrap gap-1">
        <button *ngFor="let v of views"
                (click)="onViewChange(v.key)"
                class="px-2.5 py-1 text-xs font-medium rounded-md transition-all"
                [ngClass]="activeView === v.key
                  ? 'bg-gray-800 text-white'
                  : 'bg-gray-50 text-gray-500 hover:bg-gray-100'">
          {{ v.label | translate }}
        </button>
      </div>
      <div *ngIf="projects.length > 1" class="relative" style="min-width: 160px; max-width: 200px;">
        <div class="flex items-center gap-1 px-2.5 py-1 text-xs border border-gray-200 rounded-lg bg-white cursor-pointer hover:border-gray-300 transition-colors"
             (click)="projectDropdownOpen = !projectDropdownOpen">
          <i class="fa-solid fa-search text-gray-300 text-[10px]"></i>
          <span class="truncate flex-1" [class.text-gray-400]="!selectedProject">{{ selectedProject || ('ALL_PROJECTS' | translate) }}</span>
          <i class="fa-solid fa-chevron-down text-gray-300 text-[10px]"></i>
        </div>
        <div *ngIf="projectDropdownOpen" class="absolute right-0 top-full mt-1 w-full bg-white border border-gray-200 rounded-lg shadow-lg z-50 overflow-hidden">
          <input type="text"
                 [(ngModel)]="projectSearch"
                 placeholder="Search project..."
                 class="w-full px-2.5 py-1.5 text-xs border-b border-gray-100 focus:outline-none"
                 (click)="$event.stopPropagation()">
          <div class="max-h-[150px] overflow-y-auto">
            <div class="px-2.5 py-1.5 text-xs cursor-pointer hover:bg-amber-50 transition-colors"
                 [class.text-amber-600]="!selectedProject" [class.font-medium]="!selectedProject"
                 (click)="selectProject('')">
              {{ 'ALL_PROJECTS' | translate }}
            </div>
            <div *ngFor="let p of filteredProjects"
                 class="px-2.5 py-1.5 text-xs cursor-pointer hover:bg-amber-50 truncate transition-colors"
                 [class.text-amber-600]="selectedProject === p" [class.font-medium]="selectedProject === p"
                 (click)="selectProject(p)">
              {{ p }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Chart area -->
    <div class="chart-container relative">
      <!-- Loading -->
      <div *ngIf="loading" class="flex items-center justify-center h-full">
        <ion-spinner name="crescent" color="medium"></ion-spinner>
      </div>

      <!-- Empty state -->
      <div *ngIf="!loading && !hasData" class="flex flex-col items-center justify-center h-full text-center">
        <i class="fa-solid fa-chart-bar text-gray-300 text-3xl mb-2"></i>
        <p class="text-sm text-gray-400">{{ 'NO_USAGE_DATA' | translate }}</p>
      </div>

      <!-- Chart -->
      <canvas *ngIf="!loading && hasData"
              baseChart
              [type]="chartType"
              [data]="chartData"
              [options]="chartOptions">
      </canvas>
    </div>

    <!-- Summary -->
    <div *ngIf="!loading && analyticsData?.totals as totals" class="flex flex-wrap gap-x-4 gap-y-1 mt-3 text-xs text-gray-500">
      <span class="font-medium text-gray-700">{{ totals.total }} credits</span>
      <span><span class="inline-block w-2 h-2 rounded-full bg-blue-500 mr-1"></span>Dev: {{ totals.development }}</span>
      <span><span class="inline-block w-2 h-2 rounded-full bg-emerald-500 mr-1"></span>Infra: {{ totals.infrastructure }}</span>
    </div>
  </div>
</div>
